import type { Observable } from 'rxjs';

import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import * as CatalogSelectors from './product-catalog.selectors';
import ProductCatalogActions from '@web/store/website/product-catalog/product-catalog.actions';
import type { CatalogProductCard } from '@web/widgets/product-card/type/product-card-widget.type';
import { type CatalogCategory } from '@web/widgets/product-card/type/product-card-widget.type';

@Injectable()
export class ProductCatalogFacade {
    private readonly store = inject(Store);

    public readonly categories$: Observable<CatalogCategory[]> = this.store.select(CatalogSelectors.selectCategories);
    public readonly products$: Observable<CatalogProductCard[]> = this.store.select(CatalogSelectors.selectProducts);
    public readonly selectedCategory$: Observable<number> = this.store.select(CatalogSelectors.selectSelectedCategory);
    public readonly total$: Observable<number> = this.store.select(CatalogSelectors.selectTotal);

    public readonly isLoading$: Observable<boolean> = this.store.select(CatalogSelectors.selectIsLoading);
    public readonly isTariffExpired$: Observable<boolean> = this.store.select(CatalogSelectors.selectIsTariffExpired);

    public loadCatalogContent(): void {
        this.store.dispatch(ProductCatalogActions.loadCatalogContent());
    }

    public loadProductsWithFilter(
        categoryId: number = null,
        search: string = null,
        offset: number = 0,
        limit = 24
    ): void {
        this.store.dispatch(
            ProductCatalogActions.loadProductsRequest({
                categoryId,
                search,
                offset,
                limit,
            })
        );
    }

    public setTariffExpired(isTariffExpired: boolean): void {
        this.store.dispatch(ProductCatalogActions.setTariffExpired({ isTariffExpired }));
    }

    public setSelectedCategory(category: number): void {
        this.store.dispatch(
            ProductCatalogActions.setCategory({
                category,
            })
        );
    }

    public loadCategories(): void {
        this.store.dispatch(ProductCatalogActions.loadCategoriesRequest());
    }

    public loadCategoryById(categoryId: number) {
        this.store.dispatch(
            ProductCatalogActions.loadCategoryById({
                categoryId,
            })
        );
    }
}
